export const getResizedImageUrl = (imageSrc: string | undefined, imageHeight = 200) => {
  if (!imageSrc) {
    return undefined;
  }
  if (imageSrc.startsWith("http")) {
    const url = new URL(imageSrc);
    url.searchParams.set("fit", "scale-down");
    url.searchParams.set("height", imageHeight.toString());
    if (!url.pathname.startsWith("/images/")) {
      url.pathname = `/images${url.pathname}`;
    }
    return url.toString();
  }
  return imageSrc;
};
